(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const setStoreAvailabilityReady = (button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    button.dataset.state = 'ready';
    const readyLabel = button.dataset.labelReady;
    if (readyLabel) button.textContent = readyLabel;
  };

  const initStoreAvailabilityButtons = () => {
    document.querySelectorAll('.product-details [data-store-availability-trigger]').forEach((button) => {
      const details = button.closest('.product-details');
      if (!details) return;

      if (details.dataset.sizeSelected === 'true' || button.dataset.state === 'ready') {
        setStoreAvailabilityReady(button);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initStoreAvailabilityButtons);
  document.addEventListener('shopify:section:load', initStoreAvailabilityButtons);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.closest('.product-details .variant-option--size')) return;

    const details = event.target.closest('.product-details');
    const button = details?.querySelector('[data-store-availability-trigger]');
    if (!details || !button) return;

    details.dataset.sizeSelected = 'true';
    setStoreAvailabilityReady(button);
  });

  document.addEventListener('variant:update', () => {
    document
      .querySelectorAll('.product-details[data-size-selected="true"] [data-store-availability-trigger]')
      .forEach(setStoreAvailabilityReady);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-store-availability-trigger]');
    if (!trigger) return;

    if (trigger.dataset.state !== 'ready') {
      const target =
        document.querySelector('.product-details .variant-option--size') ||
        document.querySelector('.product-details .variant-picker');

      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const dialogComponent = trigger.closest('dialog-component');
    if (dialogComponent?.showDialog) {
      dialogComponent.showDialog();
      const input = dialogComponent.querySelector('[data-store-locator-input]');
      if (input instanceof HTMLInputElement) {
        requestAnimationFrame(() => input.focus());
      }
      return;
    }
  });

  document.addEventListener('click', (event) => {
    const locationButton = event.target.closest('[data-store-locator-use-location]');
    if (!locationButton) return;

    const dialog = locationButton.closest('dialog');
    const input = dialog?.querySelector('[data-store-locator-input]');
    if (!(input instanceof HTMLInputElement) || !navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        input.value = `${position.coords.latitude.toFixed(5)}, ${position.coords.longitude.toFixed(5)}`;
        input.focus();
      },
      () => {
        input.focus();
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["complete-with"] && !Shopify.designMode) return;
  try {
    // Sprite reference rather than a Unicode currency sign, which many devices cannot render
  const COMPLETE_WITH_CURRENCY_ICON =
    '<svg class="currency-icon" width="14" height="14" fill="currentColor" aria-hidden="true" focusable="false"><use href="#currency-icon" xlink:href="#currency-icon"></use></svg>';

  const formatCompleteWithPrice = (priceEl, option) => {
    if (!(priceEl instanceof HTMLElement) || !(option instanceof HTMLOptionElement)) return;
    if (!option.dataset.priceFormatted) return;

    const onSale = option.dataset.onSale === 'true';
    priceEl.classList.toggle('complete-with__price--on-sale', onSale);

    if (onSale) {
      priceEl.innerHTML = `
        <span class="complete-with__price-sale">${COMPLETE_WITH_CURRENCY_ICON} ${option.dataset.priceFormatted}</span>
        <span class="complete-with__price-compare">${COMPLETE_WITH_CURRENCY_ICON} ${option.dataset.compareAtFormatted}</span>
      `;
      return;
    }

    priceEl.innerHTML = `<span class="complete-with__price-regular">${COMPLETE_WITH_CURRENCY_ICON} ${option.dataset.priceFormatted}</span>`;
  };

  const getCompleteWithMoneyFormat = (root) => {
    const template = root.querySelector('[data-complete-with-money-format]');
    const defaultFormat = '$' + '{' + '{amount}' + '}';
    return template?.textContent?.trim() || defaultFormat;
  };

  const formatCompleteWithCents = (cents, moneyFormat, currencyIso = '') => {
    const amount = (cents / 100).toFixed(2);
    const [whole, fraction = '00'] = amount.split('.');
    const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const placeholderOpen = '{' + '{';
    const placeholderClose = '}' + '}';
    const placeholderPattern = new RegExp(placeholderOpen + '\\s*(\\w+)\\s*' + placeholderClose, 'g');

    return moneyFormat.replace(placeholderPattern, (_, placeholder) => {
      if (placeholder === 'currency') return currencyIso;
      if (placeholder === 'amount') return `${whole}.${fraction}`;
      if (placeholder === 'amount_no_decimals') return whole;
      if (placeholder === 'amount_with_comma_separator') return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${fraction}`;
      if (placeholder === 'amount_no_decimals_with_comma_separator') return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (placeholder === 'amount_with_space_separator') return `${withThousands.replace(/,/g, ' ')}.${fraction}`;
      if (placeholder === 'amount_no_decimals_with_space_separator') return withThousands.replace(/,/g, ' ');
      return '';
    });
  };

  const getCompleteWithComplementPriceCents = (root) => {
    const select = root.querySelector('[data-complete-with-variant-select]');

    if (select instanceof HTMLSelectElement) {
      const option = select.selectedOptions[0];
      return Number(option?.dataset.priceCents) || 0;
    }

    return Number(root.dataset.complementVariantPriceCents) || 0;
  };

  const getAddToBagButtonTextEl = (productId) => {
    const form = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
    return form?.querySelector('.add-to-cart-text__content span span');
  };

  const updateAddToBagButtonLabel = (root) => {
    if (!(root instanceof HTMLElement)) return;

    const checkbox = root.querySelector('[data-complete-with-checkbox]');
    const productId = root.dataset.mainProductId;
    const buttonTextEl = productId ? getAddToBagButtonTextEl(productId) : null;

    if (!(checkbox instanceof HTMLInputElement) || !buttonTextEl) return;

    const mainPriceCents = Number(root.dataset.mainVariantPriceCents) || 0;
    const moneyFormat = getCompleteWithMoneyFormat(root);
    const currencyIso = root.dataset.currencyIso || '';
    const singleTemplate = root.dataset.labelSingle || 'Add to bag - %%PRICE%%';
    const combinedTemplate = root.dataset.labelCombined || 'Add (%%COUNT%%) to bag - %%PRICE%%';

    if (!checkbox.checked) {
      const price = formatCompleteWithCents(mainPriceCents, moneyFormat, currencyIso);
      buttonTextEl.innerHTML = singleTemplate.replace('%%PRICE%%', `${COMPLETE_WITH_CURRENCY_ICON} ${price}`);
      return;
    }

    const complementPriceCents = getCompleteWithComplementPriceCents(root);
    const totalCents = mainPriceCents + complementPriceCents;
    const totalFormatted = formatCompleteWithCents(totalCents, moneyFormat, currencyIso);

    buttonTextEl.innerHTML = combinedTemplate
      .replace('%%COUNT%%', '2')
      .replace('%%PRICE%%', `${COMPLETE_WITH_CURRENCY_ICON} ${totalFormatted}`);
  };

  const selectFirstAvailableCompleteWithVariant = (root) => {
    const select = root.querySelector('[data-complete-with-variant-select]');
    if (!(select instanceof HTMLSelectElement)) return;

    const selected = select.selectedOptions[0];
    if (selected && !selected.disabled) return;

    const firstAvailable = Array.from(select.options).find((option) => !option.disabled);
    if (firstAvailable) select.value = firstAvailable.value;
  };

  const updateCompleteWithVariant = (root) => {
    const select = root.querySelector('[data-complete-with-variant-select]');
    const priceEl = root.querySelector('[data-complete-with-price]');
    const imageEl = root.querySelector('[data-complete-with-image]');
    const checkbox = root.querySelector('[data-complete-with-checkbox]');

    if (!(select instanceof HTMLSelectElement)) {
      if (checkbox instanceof HTMLInputElement && checkbox.checked) {
        updateAddToBagButtonLabel(root);
      }
      return;
    }

    selectFirstAvailableCompleteWithVariant(root);

    const option = select.selectedOptions[0];
    if (!option) return;

    if (priceEl) formatCompleteWithPrice(priceEl, option);

    if (imageEl instanceof HTMLImageElement && option.dataset.imageUrl) {
      imageEl.src = option.dataset.imageUrl;
    }

    if (checkbox instanceof HTMLInputElement) {
      checkbox.value = option.value;
      checkbox.removeAttribute('disabled');
    }

    if (checkbox instanceof HTMLInputElement && checkbox.checked) {
      updateAddToBagButtonLabel(root);
    }
  };

  const addCompleteWithToCart = async (root) => {
    const checkbox = root.querySelector('[data-complete-with-checkbox]');
    const select = root.querySelector('[data-complete-with-variant-select]');

    if (!(checkbox instanceof HTMLInputElement) || !checkbox.checked || checkbox.disabled) return;
    if (root.dataset.completeWithPending === 'true') return;

    const variantId =
      select instanceof HTMLSelectElement
        ? select.value
        : select instanceof HTMLInputElement
          ? select.value
          : '';
    if (!variantId) return;

    const errorEl = root.querySelector('[data-complete-with-error]');
    const errorTextEl = root.querySelector('[data-complete-with-error-text]');
    if (errorEl) errorEl.classList.add('hidden');

    root.dataset.completeWithPending = 'true';

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      const result = await response.json();
      if (result.status) {
        if (errorEl && errorTextEl) {
          errorTextEl.textContent = result.message || 'This item could not be added to your bag.';
          errorEl.classList.remove('hidden');
          checkbox.checked = false;
          setTimeout(() => errorEl.classList.add('hidden'), 6000);
        }
        return;
      }

      const cart = await fetch('/cart.js').then((res) => res.json());
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: root.id || '',
            data: {
              source: 'complete-with-component',
              itemCount: cart.item_count,
            },
          },
        })
      );
    } catch (error) {
      if (errorEl && errorTextEl) {
        errorTextEl.textContent = 'This item could not be added to your bag. Please try again.';
        errorEl.classList.remove('hidden');
        checkbox.checked = false;
        setTimeout(() => errorEl.classList.add('hidden'), 6000);
      }
    } finally {
      root.dataset.completeWithPending = 'false';
    }
  };

  const initCompleteWithBlocks = (scope = document) => {
    scope.querySelectorAll('[data-complete-with]').forEach((root) => {
      if (!(root instanceof HTMLElement) || root.dataset.completeWithReady === 'true') return;
      root.dataset.completeWithReady = 'true';
      updateCompleteWithVariant(root);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initCompleteWithBlocks());
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initCompleteWithBlocks(event.target);
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches('[data-complete-with-checkbox]')) return;

    const root = event.target.closest('[data-complete-with]');
    if (root) updateAddToBagButtonLabel(root);
  });

  document.addEventListener('click', (event) => {
    const label = event.target.closest('.complete-with__checkbox-label');
    if (!label) return;

    const root = label.closest('[data-complete-with]');
    if (!root) return;

    requestAnimationFrame(() => updateAddToBagButtonLabel(root));
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-complete-with-variant-select]');
    if (!select) return;
    const root = select.closest('[data-complete-with]');
    if (root) updateCompleteWithVariant(root);
  });

  document.addEventListener('variant:update', (event) => {
    const detail = event.detail;
    const productId = detail?.data?.productId;
    const variantPrice = detail?.resource?.price;

    if (!productId || variantPrice == null) return;

    requestAnimationFrame(() => {
      document
        .querySelectorAll(`[data-complete-with][data-main-product-id="${productId}"]`)
        .forEach((root) => {
          root.dataset.mainVariantPriceCents = String(variantPrice);
          const checkbox = root.querySelector('[data-complete-with-checkbox]');
          if (checkbox instanceof HTMLInputElement && checkbox.checked) {
            updateAddToBagButtonLabel(root);
          }
        });
    });
  });

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail;
    if (detail?.data?.didError) return;
    if (detail?.data?.source !== 'product-form-component') return;

    const mainProductId = detail?.data?.productId;
    if (!mainProductId) return;

    const root = document.querySelector(
      `[data-complete-with][data-main-product-id="${mainProductId}"]:not([data-complete-with-placeholder])`
    );
    if (root) addCompleteWithToCart(root);
  });
  } catch(e) { console.error(e); }
})();

})();
